import { styled } from '$utils/theme'
import { rem } from 'polished'
import { Block, Button } from '$views/components'

const headerHeightMobile = 50
const headerHeightDesktop = 72
const containerSearchBlockPadding = 32
const seeCaretakers = 24
const locationSearchInputHeight = 48
const familySearchingText = 31
const familySearchingTextDesktop = 40
const careTypeButtons = 44

interface Props {
  windowHeight: number
}

export const FullMapWrapper = styled.div`
  position: relative;
  top: 3rem;
  ${p => p.theme.media.desktop`
  top: 4.5rem;
  `};
`

export const FullMapCaretakersWrapper = styled.div<Props>`
  height: ${p =>
    `calc(${rem(p.windowHeight)}  - ${rem(headerHeightMobile)} -  ${rem(containerSearchBlockPadding)} - ${rem(
      seeCaretakers,
    )} - ${rem(locationSearchInputHeight)} - ${rem(familySearchingText)} - ${rem(
      careTypeButtons,
    )})`}; //100% menos la altura de la cabecera, del input y de los textos
  ${p => p.theme.media.desktop`
      height: ${`calc(${rem(p.windowHeight)} - ${rem(headerHeightDesktop)} - ${rem(
        containerSearchBlockPadding,
      )}  - ${rem(seeCaretakers)} - ${rem(locationSearchInputHeight)} - ${rem(familySearchingTextDesktop)})`};
  `}
  position: relative;
`

export const ContainerSearchBlock = styled(Block)`
  padding: ${p => rem(p.theme.sizes.mini)};
  width: 100%;
  max-width: 1160px;
  margin: auto;
`

export const ContainerSearchFamily = styled(Block)`
  padding: ${p => rem(p.theme.sizes.base)} ${p => rem(p.theme.sizes.mini)};
  width: 100%;
  max-width: 1160px;
  margin: auto;
`

export const SearchFamilyWrapper = styled.div`
  width: 100%;
  border-top: ${p => p.theme.colors.lightGrey} 1px solid;
`

export const StyledSearchBlock = styled(Block)`
  ${p => p.theme.media.desktop`
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;

    align-items: end;
  `}
`

export const StyledAskNearCaretakersButton = styled(Button)`
  z-index: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  position: absolute;
  left: 0px;
  right: 0px;
  margin: auto;
  bottom: 2rem;
  width: fit-content;
  background-color: ${p => p.theme.colors.yellow};
  border-color: ${p => p.theme.colors.yellow};
  color: ${p => p.theme.colors.darkGrey};
  &:hover {
    background-color: ${p => p.theme.colors.darkYellow};
    border-color: ${p => p.theme.colors.darkYellow};
  }
  &:active {
    background-color: ${p => p.theme.colors.darkYellow};
    border-color: ${p => p.theme.colors.darkYellow};
  }
`



// WEBPACK FOOTER //
// ./src/views/FullMapCaretakers/FullMapCaretakers.style.ts